import React, { useEffect, useState } from "react";
import LanguageSelect from "./LanguageSelect";
import { languages } from "../data/headerData";
import i18n from "../../../i18n";

const LanguageDetector: React.FC = () => {
  // Get saved language or fallback to i18n default
  const savedLangCode = localStorage.getItem("appLang") || i18n.language;
  const initialLang = languages.find((l) => l.code === savedLangCode) || languages[0];
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    if (lang?.code) {
      i18n.changeLanguage(lang.code).then(() => {
        document.documentElement.dir = lang.code === "ar" ? "rtl" : "ltr";
        document.documentElement.lang = lang.code;

        const storedLang = localStorage.getItem("appLang");

        // Reload only once per language change
        if (storedLang !== lang.code) {
          localStorage.setItem("appLang", lang.code);
          window.location.reload();
        }
      });
    }
  }, [lang]);

  return (
    <div>
      <LanguageSelect
        languages={languages}
        current={lang}
        onChange={setLang}
      />
    </div>
  );
};

export default LanguageDetector;
